import { CustomArray } from "../../../common/CustomArray";
import { POIItemInfo } from "./POIItemInfo"

export class POIItemInfos extends CustomArray {

	constructor() {
		super();

	}


	static GetPOIItems(jsonItems) {
		let curItems = null;
		if (jsonItems == null) return curItems;
		curItems = new POIItemInfos();
		let tempItem = null;
		for (let tempIndex in jsonItems) {
			tempItem = POIItemInfo.GetPOIItem(jsonItems[tempIndex]);
			curItems.push(tempItem);
		}

		return curItems;
	}

}//end POIItemInfos

